import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";
import { OW_API } from "./operatorWalk";

const TOKEN_KEY = "ow_token";

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  // null = checking, user object = authed, false = not authed
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || null);

  const verify = useCallback(async (t) => {
    if (!t) {
      setUser(false);
      return;
    }
    try {
      const res = await axios.get(`${OW_API}/auth/me`, {
        headers: { Authorization: `Bearer ${t}` },
      });
      setUser(res.data.user);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    verify(token);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = async (email, password) => {
    const res = await axios.post(`${OW_API}/auth/login`, { email, password });
    const t = res.data?.token;
    if (!t) throw new Error("No token returned");
    localStorage.setItem(TOKEN_KEY, t);
    setToken(t);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(false);
  };

  const updateUser = (patch) => {
    setUser((prev) => (prev ? { ...prev, ...patch } : prev));
  };

  const authHeader = token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <PortalAuthContext.Provider value={{ user, token, login, logout, updateUser, authHeader }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export function usePortalAuth() {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error("usePortalAuth must be used within PortalAuthProvider");
  return ctx;
}
